import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules, withComponentInputBinding
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { importProvidersFrom } from '@angular/core';
import { IonicStorageModule } from '@ionic/storage-angular';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { authRefreshInterceptor } from './app/interceptors/auth-refresh.interceptor';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Capacitor } from '@capacitor/core';

// iOS WebView does not natively resize when the soft keyboard appears, so
// Ionic's scroll-assist polyfill is required there. Android (with the
// `windowSoftInputMode=adjustResize` we set in AndroidManifest.xml + Capacitor
// Keyboard's `resizeOnFullScreen`) resizes the WebView natively. Running
// scroll-assist on top of native resize double-corrects: it adds an extra
// keyboard-height of padding/scroll, which pushes inputs off-screen and lifts
// `ion-footer` far above the keyboard with a large empty gap. Disable the
// polyfills on Android and let the native resize handle it.
const isIos = Capacitor.getPlatform() === 'ios';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideAnimations(),
    importProvidersFrom(MatFormFieldModule),
    provideIonicAngular({
      inputShims: isIos,
      scrollAssist: isIos,
      scrollPadding: isIos,
      hideCaretOnScroll: isIos,
    }),
    importProvidersFrom(IonicStorageModule.forRoot()),
    provideHttpClient(withInterceptors([authRefreshInterceptor])),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withPreloading(PreloadAllModules)),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [HttpClient],
        },
      })
    ),
  ],
}).then(appRef => {
  const translate = appRef.injector.get(TranslateService);
  translate.setDefaultLang('en');  // Set default language
  translate.use('en');  // Load initial language
});
